/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Zotero_LibraryInputs */

const en_why_listening_zotero_library = /** @type {(inputs: Why_Listening_Zotero_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zotero library`)
};

const es_why_listening_zotero_library = /** @type {(inputs: Why_Listening_Zotero_LibraryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biblioteca de Zotero`)
};

/**
* | output |
* | --- |
* | "Zotero library" |
*
* @param {Why_Listening_Zotero_LibraryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_zotero_library = /** @type {((inputs?: Why_Listening_Zotero_LibraryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Zotero_LibraryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_zotero_library(inputs)
	return en_why_listening_zotero_library(inputs)
});